// File: src/pages/Admin/GPTDocAgentAdmin.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../config/config";
import AdminPageFrame from "../../components/admin/AdminPageFrame";

const GPTDocAgentAdmin = () => {
  const [filePath, setFilePath] = useState("src/routes/gptRoutes.js");
  const [folderPath, setFolderPath] = useState("src/routes");
  const [markdown, setMarkdown] = useState("");
  const [index, setIndex] = useState([]);
  const [loading, setLoading] = useState(false);
  const [autodocStatus, setAutodocStatus] = useState(null);

  const runFileDoc = async () => {
    setLoading(true);
    setMarkdown("");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/doc/file`, { filePath });
      setMarkdown(`✅ Datei dokumentiert: ${res.data.file}\n\nGespeichert unter:\n${res.data.output}`);
    } catch (err) {
      console.error(err);
      setMarkdown("❌ Fehler bei der Dokumentation.");
    } finally {
      setLoading(false);
    }
  };

  const runFolderDoc = async () => {
    setLoading(true);
    setMarkdown("");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/doc/folder`, { folder: folderPath });
      setMarkdown(`📂 Ordner verarbeitet: ${res.data.processed} Dateien`);
    } catch (err) {
      console.error(err);
      setMarkdown("❌ Fehler bei der Ordnerdokumentation.");
    } finally {
      setLoading(false);
    }
  };

  const runAutoDocNow = async () => {
    setMarkdown("🚀 AutoDoc wird jetzt gestartet...");
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/autodoc/trigger`);
      setMarkdown(`✅ AutoDoc abgeschlossen: ${res.data.result.updated} Datei(en) aktualisiert.`);
      loadIndex(); // Aktualisiere Index nach Doc-Update
      loadAutoDocStatus();
    } catch (err) {
      setMarkdown("❌ Fehler bei AutoDoc: " + err.message);
    }
  };

  const loadIndex = async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/api/gpt/doc/index`);
      setIndex(res.data.index);
    } catch (err) {
      console.error("❌ Fehler beim Laden des Index", err);
    }
  };

  const loadAutoDocStatus = async () => {
    try {
      const res = await axios.get(`${config.API_BASE_URL}/api/gpt/autodoc/status`);
      setAutodocStatus(res.data);
    } catch (err) {
      console.error("❌ Fehler beim Laden des AutoDoc-Status", err);
    }
  };

  useEffect(() => {
    loadIndex();
    loadAutoDocStatus();
  }, []);

  return (
    <AdminPageFrame
      title="GPT DocAgent"
      subtitle="Datei- und Ordnerdokumentation, AutoDoc-Lauf und Indexzugriff im Admin-Arbeitsraum."
      badge="Documentation Ops"
    >
      <div className="admin-workbench">
        <section className="admin-workbench__panel">
          <div className="admin-workbench__grid admin-workbench__grid--split">
            <div className="admin-workbench__field">
              <label htmlFor="docagent-file">Einzeldatei dokumentieren</label>
              <input
                id="docagent-file"
                type="text"
                value={filePath}
                onChange={(e) => setFilePath(e.target.value)}
                className="admin-workbench__input"
              />
              <button type="button" onClick={runFileDoc} disabled={loading} className="admin-workbench__button admin-workbench__button--primary">
                {loading ? "Dokumentiert..." : "Dokumentation starten"}
              </button>
            </div>

            <div className="admin-workbench__field">
              <label htmlFor="docagent-folder">Ordner dokumentieren</label>
              <input
                id="docagent-folder"
                type="text"
                value={folderPath}
                onChange={(e) => setFolderPath(e.target.value)}
                className="admin-workbench__input"
              />
              <button type="button" onClick={runFolderDoc} disabled={loading} className="admin-workbench__button admin-workbench__button--success">
                {loading ? "Scanne..." : "Ordner scannen und dokumentieren"}
              </button>
            </div>
          </div>
        </section>

        <section className="admin-workbench__panel">
          <div>
            <h3>AutoDocEngine</h3>
            {autodocStatus ? (
              <p className="admin-workbench__copy">
                Letzter Lauf: {new Date(autodocStatus.lastRun).toLocaleString("de-DE", {
                  dateStyle: "short",
                  timeStyle: "short"
                })} | Dateien im System: {autodocStatus.files}
              </p>
            ) : null}
          </div>
          <div className="admin-workbench__actions">
            <button
              type="button"
              onClick={runAutoDocNow}
              disabled={loading}
              className="admin-workbench__button admin-workbench__button--primary"
            >
              Jetzt AutoDoc starten
            </button>
          </div>
        </section>

        {markdown ? <pre className="admin-workbench__code">{markdown}</pre> : null}

        <section className="admin-workbench__panel">
          <div>
            <h3>Inhaltsverzeichnis (/docs)</h3>
            <p className="admin-workbench__copy">Alle dokumentierten Dateien bleiben direkt aus dem DocAgent erreichbar.</p>
          </div>
          <ul className="admin-workbench__list">
            {index.length > 0 ? (
              index.map((item, idx) => (
                <li key={idx}>
                  <a href={item.path} target="_blank" rel="noopener noreferrer">
                    {item.file}
                  </a>
                </li>
              ))
            ) : (
              <li>Keine Dokumentation gefunden.</li>
            )}
          </ul>
        </section>
      </div>
    </AdminPageFrame>
  );
};

export default GPTDocAgentAdmin;
